<template>
    <div class="col-12 mx-auto">
        <div class="card">
            <div class="card-header" v-if="showNewButton || showSettingsBtn">
                <button type="button" class="btn btn-primary btn-lg" v-if="showNewButton && hasParticipantEditRights" @click="createBtnClick">{{$t('buttons.create.btnText')}}</button>
                <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                   v-if="showSettingsBtn"
                   @click.stop="changeGridSettings"
                   data-toggle="tooltip"
                   :title="settingsTooltipText"></i>

                <grid-user-settings ref="userSettings"
                                    :schemaModelFields="schemaModelFields"
                                    :componentName="componentName"
                                    :useLabelAsTitle="true"
                                    :showUserSettings="true"
                                    :gridOptions="userSettings"
                                    v-if="showUserSettingsForm"
                                    @saveGridSettings="saveGridSettings"
                                    @loadGridSettings="loadGridSettings"
                                    @userSettingsChanged="userSettingsChanged">
                </grid-user-settings>
            </div>

            <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
                <div class="form-inline col-lg-6 col-md-12">

                </div>

                <div class="input-group col-lg-6 col-md-12">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch"  v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>

            <div class="card-body">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :filter="filter"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size="gridOptions.pageable.size"
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd"></kendo-datasource>
                <kendo-grid ref="participantsGrid"
                            :data-source-ref="'datasource1'"
                            ::navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="toolbar"
                            :excel="gridOptions.excel"
                            :data-bound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :filterable="false"
                                       :title="$t('registers.events.participants.gridHeaders.id')"
                                       :width="100"
                                       :hidden="true"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventName'"
                                       :title="$t('registers.events.participants.gridHeaders.eventName')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="true"
                                       :hidden="!listAllKind">
                    </kendo-grid-column>
                    <kendo-grid-column v-if="showBtns && hasParticipantEditRights"
                                       :filterable="false"
                                       field="btnsColumn"
                                       :title="$t('registers.events.participants.gridHeaders.management')"
                                       :sortable="false"
                                       :template="btnsTemplate"
                                       :width="100"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLocation'"
                                       :title="$t('registers.events.gridHeaders.eventLocation')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStartDate'"
                                       :title="$t('registers.events.gridHeaders.eventStartDate')"
                                       :width="200"
                                       :format="'{0: dd.MM.yyyy}'"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventEndDate'"
                                       :title="$t('registers.events.gridHeaders.eventEndDate')"
                                       :width="200"
                                       :format="'{0: dd.MM.yyyy}'"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationType'"
                                       :title="$t('registers.events.participants.gridHeaders.participationType')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationTypeEn'"
                                       :title="$t('registers.events.participants.gridHeaders.participationType')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'syncWithMoodle'"
                                       :title="$t('registers.events.participants.gridHeaders.syncWithMoodle')"
                                       :width="100"
                                       :template="syncedCellTemplate"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="listAllKind">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isFromTempRanking'"
                                       :title="$t('registers.events.participants.gridHeaders.isFromTempRanking')"
                                       :width="100"
                                       :template="tempRankCellTemplate"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="listAllKind">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'titleDegree'"
                                       :title="$t('registers.events.participants.gridHeaders.titleDegree')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'titleDegreeEn'"
                                       :title="$t('registers.events.participants.gridHeaders.titleDegree')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'fullName'" :title="$t('registers.events.participants.gridHeaders.name')" :width="300" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'identificationType'"
                                       :title="$t('registers.events.participants.gridHeaders.identificationType')"
                                       :width="100"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'identificationNumber'"
                                       :title="$t('registers.events.participants.gridHeaders.identificationNumber')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'email'"
                                       :title="$t('registers.events.participants.gridHeaders.email')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'position'"
                                       :title="$t('registers.events.participants.gridHeaders.position')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionEn'"
                                       :title="$t('registers.events.participants.gridHeaders.position')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionStatistic'"
                                       :title="$t('registers.events.participants.gridHeaders.positionStatistic')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionStatisticEn'"
                                       :title="$t('registers.events.participants.gridHeaders.positionStatistic')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionStr'"
                                       :title="$t('registers.events.participants.gridHeaders.positionFullName')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'educationDegree'"
                                       :title="$t('registers.events.participants.gridHeaders.educationDegree')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'educationDegreeEn'"
                                       :title="$t('registers.events.participants.gridHeaders.educationDegree')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'institutionRegister'"
                                       :title="$t('registers.events.participants.gridHeaders.institutionNomenclature')"
                                       :width="250"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'institutionRegisterLocation'"
                                       :title="$t('registers.events.participants.gridHeaders.institutionCity')"
                                       :width="250"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'relationTypeName'"
                                       :title="$t('registers.events.participants.gridHeaders.relationType')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'relationTypeNameEn'"
                                       :title="$t('registers.events.participants.gridHeaders.relationType')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'cityOfCurrentAddress'"
                                       :title="$t('reportData.participants.cityOfCurrentAddress')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'currentSettlement'"
                                       :title="$t('reportData.participants.currentSettlement')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'currentSettlementEn'"
                                       :title="$t('reportData.participants.currentSettlement')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'createdAt'"
                                       :title="$t('registers.events.participants.gridHeaders.createdAt')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :format="'{0: dd-MM-yyyy HH:mm:ss}'"
                                       :hidden="!hasParticipantEditRights">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'updatedAt'"
                                       :title="$t('registers.events.participants.gridHeaders.updatedAt')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :format="'{0: dd-MM-yyyy HH:mm:ss}'"
                                       :hidden="!hasParticipantEditRights">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>

        <PersonEditModal v-model="personModel" :show="showPersonEdit" @onClose="onPersonEditClose" @onSave="onPersonEdit"></PersonEditModal>
        <PersonDetailsModal v-model="personModel" :show="showPersonDetails" :allowEdit="false" @onClose="onPersonDetailsClose"></PersonDetailsModal>
        <ParticipantEditModal v-model="participantModel" :show="showParticipanrEdit" @onClose="onParticipantEditClose" @onSave="onParticipantEdit"></ParticipantEditModal>

    </div>
</template>
<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import GridUserSettings from "../../components/grid/UserSettings";
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import { Culture } from '../../models/enums';
    import PersonEditModal from '../../components/person/edit.modal';
    import PersonDetailsModal from '../../components/person/details.modal';
    import personService from '../../services/person.service';
    import participantService from '../../services/participant.service';
    import ParticipantEditModal from '../../components/participants/edit.modal';
    import { mapGetters } from 'vuex';


    /*
    Renders the grid in "DejaVu Sans" font family, which is
    declared in kendo.common.css. It also declares the paths to the
    fonts below using <tt>kendo.pdf.defineFont</tt>, because the
    stylesheet is hosted on a different domain.
    */
    kendo.pdf.defineFont({
        "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
        "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
        "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
    });

    export default {
        name: 'ParticipantsGrid',
        components: {
            'grid-user-settings': GridUserSettings,
            PersonEditModal,
            PersonDetailsModal,
            ParticipantEditModal
        },
        created: function () {
            window.JSZip = JSZip // ���������� � �� �� ������ �������� � excel
        },
        props: {
            // ����������, ����� ������� �� ���������� � �������� �� ������� �����������
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: true,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            relatedEventId: {
                default: 0,
                type: Number
            },
            listAllKind: {
                default: false, //All kind of participation (Lecturer, Participant, Mendor ....)
                type: Boolean
            },
            forLoggedUser: {
                default: false,
                type: Boolean
            },
            showMasterDetails: {
                default: false,
                type: Boolean
            },
            componentName: {
                default: 'ParticipantsListGrid',
                type: String
            },
            userId: {
                type: String,
                default: null
            },
            personId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                titleKey: 'registers.events.participants.title',
                searchQuery: '',
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true },
                    registerEntityId: {
                        name: 'registerEntityId',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    registerFieldId: {
                        name: 'registerFieldId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    personId: { name: 'personId', type: 'number', editable: false, nullable: false, visible: true },
                    eventName: { name: 'eventName', type: 'string', editable: false, nullable: true, visible: true },
                    eventLocation: { name: 'eventLocation', type: 'string', editable: false, nullable: true, visible: true },
                    relationTypeId: {
                        name: 'relationTypeId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    participationType: {
                        name: 'participationType',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    participationTypeEn: {
                        name: 'participationTypeEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    relationTypeName: {
                        name: 'relationTypeName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    relationTypeNameEn: {
                        name: 'relationTypeNameEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    isRelationTypeForParticipation: {
                        name: 'isRelationTypeForParticipation',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    relationTypeCode: {
                        name: 'relationTypeCode',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    eventPersonTypeId: {
                        name: 'eventPersonTypeId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    registerEntityParticipantMigrationId: {
                        name: 'registerEntityParticipantMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    createdBy: { name: 'createdBy', type: 'string', editable: false, nullable: true, visible: true },
                    createdAt: { name: 'createdAt', type: 'date', editable: false, nullable: true, visible: true },
                    updatedBy: { name: 'updatedBy', type: 'string', editable: false, nullable: true, visible: true },
                    updatedAt: { name: 'updatedAt', type: 'date', editable: false, nullable: true, visible: true },
                    eventStartDate: { name: 'eventStartDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventEndDate: { name: 'eventEndDate', type: 'date', editable: false, nullable: true, visible: true },
                    migrationData: {
                        name: 'migrationDataS',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    rejected: { name: 'rejected', type: 'boolean', editable: false, nullable: false, visible: true },
                    deleted: { name: 'deleted', type: 'boolean', editable: false, nullable: false, visible: true },
                    firstName: { name: 'firstName', type: 'string', editable: false, nullable: true, visible: true },
                    middleName: { name: 'middleName', type: 'string', editable: false, nullable: true, visible: true },
                    lastName: { name: 'lastName', type: 'string', editable: false, nullable: true, visible: true },
                    fullName: { name: 'fullName', type: 'string', editable: false, nullable: true, visible: true },
                    identificationType: {
                        name: 'identificationType',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    identificationNumber: {
                        name: 'identificationNumber',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    phone: { name: 'phone', type: 'string', editable: false, nullable: true, visible: true },
                    mobilePhone: { name: 'mobilePhone', type: 'string', editable: false, nullable: true, visible: true },
                    email: { name: 'email', type: 'string', editable: false, nullable: true, visible: true },
                    position: { name: 'position', type: 'string', editable: false, nullable: true, visible: true },
                    positionEn: { name: 'positionEn', type: 'string', editable: false, nullable: true, visible: true },
                    description: { name: 'description', type: 'string', editable: false, nullable: true, visible: true },
                    gender: { name: 'gender', type: 'string', editable: false, nullable: true, visible: true },
                    genderEn: { name: 'genderEn', type: 'string', editable: false, nullable: true, visible: true },
                    hasParent: { name: 'hasParent', type: 'boolean', editable: false, nullable: true, visible: true },
                    parentFirstName: {
                        name: 'parentFirstName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    parentMiddleName: {
                        name: 'parentMiddleName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    parentLastName: {
                        name: 'parentLastName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    parentFullName: {
                        name: 'parentFullName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    username: { name: 'username', type: 'string', editable: false, nullable: true, visible: true },
                    participantMigrationId: {
                        name: 'participantMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    lecturerMigrationId: {
                        name: 'lecturerMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    organizerMigrationId: {
                        name: 'organizerMigrationId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    educationDegree: {
                        name: 'educationDegree',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    educationDegreeEn: {
                        name: 'educationDegreeEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    titleDegree: { name: 'titleDegree', type: 'string', editable: false, nullable: true, visible: true },
                    titleDegreeEn: {
                        name: 'titleDegreeEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionNomenclature: {
                        name: 'institutionNomenclature',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionNomenclatureEn: {
                        name: 'institutionNomenclatureEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionRegister: {
                        name: 'institutionRegister',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionRegisterLocation: {
                        name: 'institutionRegisterLocation',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    hasChanges: { name: 'hasChanges', type: 'boolean', editable: false, nullable: true, visible: true },
                    syncWithMoodle: {
                        name: 'syncWithMoodle',
                        type: 'boolean',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    syncMoodleResult: {
                        name: 'syncMoodleResult',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    isFromTempRanking: {
                        name: 'isFromTempRanking',
                        type: 'boolean',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    positionStatisticEn: {
                        name: "positionStatisticEn",
                        type: "string",
                        editable: false,
                        nullable: true,
                        visible: true,
                    },
                    positionStr: {
                        name: "positionStr",
                        type: "string",
                        editable: false,
                        nullable: true,
                        visible: true,
                    },
                    cityOfCurrentAddress: {
                        name: "cityOfCurrentAddress",
                        type: "string",
                        editable: false,
                        nullable: true,
                        visible: true,
                    },
                    currentSettlement: {
                        name: "currentSettlement",
                        type: "string",
                        editable: false,
                        nullable: true,
                        visible: true,
                    },
                    currentSettlementEn: {
                        name: "currentSettlementEn",
                        type: "string",
                        editable: false,
                        nullable: true,
                        visible: true,
                    },
                },
                formToEventFields: {
                    id: { name: 'id', from: 'id', type: 'number', nullable: false },
                    name: { name: 'name', from: 'name', type: 'string', nullable: false },
                    nameEn: { name: 'name', from: 'name', type: 'string', nullable: true },
                    type: { name: 'name', from: 'name', type: 'string', nullable: true },
                    typeEn: { name: 'name', from: 'name', type: 'string', nullable: true }
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    toolbar: ['excel', 'pdf'],
                    excel: {
                        fileName: 'Participants.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                    pdf: {
                        fileName: 'Participants.pdf',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        margin: { top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' },
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                },
                working: false,
                showUserSettingsForm: false,
                showPersonEdit: false,
                personModel: null,
                showPersonDetails: false,
                participantModel: null,
                showParticipanrEdit: false,
            }
        },
        methods: {
            dataBound(ev) {
                if (this.showSettingsBtn) {
                    if (!this.customSettingsLoaded) {
                        this.customSettingsLoaded = true;
                        this.loadGridSettings();
                    }
                }

                //if (this.showMasterDetails) {
                //    ev.sender.expandRow(ev.sender.tbody.find('tr.k-master-row').first())
                //}
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // ������ POST action �� �������� �� �������������� � ������ �� �������������
                    // options. ���� �� ������� ���������� �� take, skip , page � ������ � ������
                    // �������� �����������
                    this.saveState();
                    return kendo.stringify(options);
                }
            },
            saveGridSettings() {
                let grid = this.$refs.participantsGrid.kendoWidget();

                if (grid) {
                    // ������� ������ ��������� �� ���������� � ��������������� ���������
                    this.$refs.userSettings.setGridSettings(grid.getOptions());
                }

                let options = grid.getOptions();

                this.$http.post('/api/personalization/saveGridSettings', {
                    componentName: this.componentName,
                    gridSettings: JSON.stringify(options)
                }).then((response) => {
                    this.$vs.notify({
                        title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                        text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            loadGridSettings() {
                return this.$http.get('/api/personalization/' + this.componentName + '/getGridSettings'
                ).then((response) => {
                    if (response.data.settings === null || !response.data.settings) {
                        // ������� �������� ������� � �� � ������������� ���������. ����� ���� �� ������������

                        return;
                    }

                    try {
                        let options = JSON.parse(response.data.settings); // ������������� ����������� �������� � ������, ��� ��� ������
                        if (!options || !options.hasOwnProperty("columns")) {
                            // ������� ������� ���������
                            return;
                        }

                        let grid = this.$refs.participantsGrid.kendoWidget();
                        if (grid) {
                            grid.setOptions(options);

                            if (options.pageable.size != grid.dataSource.options.pageSize) {
                                grid.dataSource.pageSize(options.pageable.size);
                                grid.refresh();
                            }

                            // ������� ������ ��������� �� ���������� � ��������������� ���������
                            this.$refs.userSettings.setGridSettings(grid.getOptions());
                        }

                        //this.$vs.notify({
                        //    title: '',
                        //    text: this.$t('personalSettingsLoaded'),
                        //    color: 'success',
                        //    time: this.$store.getters.notificationDuration,
                        //})
                    } catch (e) {

                    }
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            userSettingsChanged(userSettings, pageSizeChanged) {
                let grid = this.$refs.participantsGrid.kendoWidget();

                if (grid) {
                    try {
                        grid.setOptions(userSettings);
                        if (pageSizeChanged === true) {
                            grid.dataSource.pageSize(userSettings.pageable.size);
                            grid.refresh();
                        }
                    } catch (e) {
                        return;
                    }
                }
            },
            saveState: function () {
                let grid = this.$refs.participantsGrid.kendoWidget();

                localStorage['' + this.commandName + "-grid-options"] = kendo.stringify(grid.getOptions());
            },
            loadState: function () {
                let options = localStorage["organizers-grid-options"];
                let grid = this.$refs.participantsGrid.kendoWidget();

                if (options) {
                    grid.setOptions(JSON.parse(options));
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            resize(componentName, size) {
                this.$emit('resize', componentName, size, this.$refs.participantsGrid.kendoWidget())
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            hide(componentName) {
                this.$emit('hide', componentName)
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            pinned(componentName) {
                this.$emit('pinned', componentName)
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            unpinned(componentName) {
                this.$emit('unpinned', componentName)
            },
            datasorceRequestEnd(e) {
                if (e.type == "read" && e.response) {
                    // 	console.log(e.response[0]);
                    //alert(e.respondashboard-ctrlse[0].TaskID);
                }
            },
            deactivatedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deactivated ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deactivated ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            isTemplateCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isTemplate ? 'badge-success' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.isTemplate ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            statusCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.status.indexOf('Active') >= 0 ? 'badge-success' : (dataItem.status.indexOf('Passed') >= 0 ? 'badge-warning' : 'badge-info')) + '">' + kendo.htmlEncode(dataItem.status) + '</span>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.participantsGrid,
                        btns: this.gridBtns
                    }
                }
            },
            detailsBtnClick(args) {
                if (!this.hasParticipantEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push('/account/' + args.personId);
            },
            eventDetailsBtnClick(args) {
                if (!this.$store.getters.claims.event.read) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push('/registers/events/edit/' + args.registerEntityId);
            },
            editBtnClick(args) {
                if (!this.hasParticipantEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push('/participant/edit?id=' + args.id);

                //let routeData = this.$router.resolve({ name: 'eventParticipantEdit', query: { id: args.id } });
                //window.open(`${this.$store.getters.baseUrl}${routeData.href}`, '_blank');
            },
            personEditBtnClick(args) {
                if (!this.hasPersonEditRights) {
                    return this.$router.push(`/unauthorized`);
                }
                this.showPersonEditModal(Number(args.personId));
            },
            personDetailsBtnClick(args) {
                if (!this.hasPersonReadRights) {
                    return this.$router.push(`/unauthorized`);
                }
                this.showPersonDetailsModal(Number(args.personId));
            },
            softDeleteBtnClick(args) {
                if (!this.hasParticipantDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                kendo.confirm(`${this.$t('registers.events.participants.confirmations.delete')} ${args.fullName}?`)
                    .then(function () {
                        this.softDeleteParticipant(args.id);
                    }.bind(this));
            },
            deleteWithPersonBtnClick(args) {
                if (!this.hasParticipantWithPersonDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                kendo.confirm(`${this.$t('registers.events.participants.confirmations.delete')} ${args.fullName}?`)
                    .then(function () {
                        this.deleteParticipantWithPerson(args.id);
                    }.bind(this));
            },
            realDeleteBtnClick(args) {
                if (!this.hasParticipantDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                kendo.confirm(`${this.$t('registers.events.participants.confirmations.delete')} ${args.fullName}?`)
                    .then(function () {
                        this.realDeleteParticipant(args.id);
                    }.bind(this));
            },
            softDeleteParticipant(id) {
                this.$http.delete('/api/participant/softDeleteParticipant',
                    { params: { id: id } }
                ).then((response) => {
                    this.refresh();

                    let statusCode = Number(this.$helpers.responseStatusCode(response));
                    this.$vs.notify({
                        title: this.$t('buttons.delete.action'),
                        text: this.$helpers.responseMessage(response),
                        color: statusCode === 240 ? 'warning' : 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {


                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            realDeleteParticipant(id) {
                this.$http.delete('/api/participant/realDelete',
                    { params: { id: id } }
                ).then((response) => {
                    this.refresh();

                    let statusCode = Number(this.$helpers.responseStatusCode(response));
                    this.$vs.notify({
                        title: this.$t('buttons.delete.action'),
                        text: this.$helpers.responseMessage(response),
                        color: statusCode === 240 ? 'warning' : 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {

                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            deleteParticipantWithPerson(id) {
                this.$http.delete('/api/participant/realDeleteWithPerson',
                    { params: { id: id } }
                ).then((response) => {
                    this.refresh();

                    let statusCode = Number(this.$helpers.responseStatusCode(response));
                    this.$vs.notify({
                        title: this.$t('buttons.delete.action'),
                        text: this.$helpers.responseMessage(response),
                        color: statusCode === 240 ? 'warning' : 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {

                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            refresh() {
                const grid = this.$refs.participantsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            createBtnClick() {

            },
            syncWithMoodle(args) {
                if (!this.hasParticipantEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$emit("syncWithMoodle", args.id);
            },
            syncedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.syncWithMoodle ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.syncWithMoodle ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            tempRankCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isFromTempRanking ? 'badge-success' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.isFromTempRanking ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            onPersonEditClose() {
                this.showPersonEdit = false;
                this.personModel = null;
            },
            onPersonDetailsClose() {
                this.showPersonDetails = false;
                this.personModel = null;
            },
            onPersonEdit(item) {
                this.refresh();
            },
            onParticipantEditClose() {
                this.showParticipanrEdit = false;
                this.participantModel = null;
            },
            onParticipantEdit(item) {
                this.refresh();
            },
            participantEditNewBtnClick(args) {
                if (!this.hasParticipantEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showParticipantEditModal(args.id);
            },
            showPersonEditModal(id) {
                personService
                    .getById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.personModel = model;
                            this.showPersonEdit = true;
                        } else {
                            this.editModel = null;
                            this.showPersonEdit = false;
                        }
                    })
                    .catch(error => {
                        this.personModel = null;
                        this.showPersonEdit = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            showPersonDetailsModal(id) {
                personService
                    .getById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.personModel = model;
                            this.showPersonDetails = true;
                        } else {
                            this.editModel = null;
                            this.showPersonDetails = true;
                        }
                    })
                    .catch(error => {
                        this.personModel = null;
                        this.showPersonDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            showParticipantEditModal(id) {
                participantService
                    .getById(id)
                    .then(response => {
                        let model = response.data.participant;
                        if (model) {
                            this.participantModel = model;
                            this.showParticipanrEdit = true;
                        } else {
                            this.participantModel = null;
                            this.showParticipanrEdit = false;
                        }
                    })
                    .catch(error => {
                        this.participantModel = null;
                        this.showParticipanrEdit = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.participantsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.participantsGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
        },
        computed:
        {
            ...mapGetters(['allowParticipantsSoftDelete']),
            token: function () {
                return this.$store.getters.authToken;
            },
            userSettings() {
                let grid = this.$refs.participantsGrid.kendoWidget();
                return grid.getOptions();
            },
            filter() {
                let eventId = Number(this.relatedEventId);
                if (isNaN(eventId) || eventId <= 0 || this.listAllKind) {
                    return {};
                }

                return {
                    logic: "and", filters: [
                        {
                            field: 'RegisterEntityId',
                            operator: 'eq',
                            value: this.relatedEventId
                        }]
                }
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            toolbar: function () {
                return [{ name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }]
            },
            transportSettings() {
                let urlSuffix = '';
                if (this.listAllKind) {
                    if (this.forLoggedUser) {
                        urlSuffix = 'listAllKindForUser';
                    } else {
                        if (this.userId) {
                            urlSuffix = 'listAllKindForUser/' + this.userId;
                        } else if (this.personId) {
                            urlSuffix = 'listAllKindForPerson/' + this.personId;
                        }
                        else {
                            urlSuffix = 'listAllKind';
                        }
                    }
                } else {
                    if (this.relatedEventId) {
                        urlSuffix = 'participantsForEvent';
                    } else {
                        urlSuffix = 'listAllParticipants';
                    }
                }

                return {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/participant/' + urlSuffix,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                }
            },
            isEventManagement() {
                let relatedEventId = Number(this.relatedEventId);
                return !isNaN(relatedEventId) && relatedEventId > 0;
            },
            hasPersonEditRights() {
                return this.$store.getters.claims.person.update;
            },
            hasPersonReadRights() {
                return this.$store.getters.claims.person.read;
            },
            hasParticipantEditRights() {
                return this.$store.getters.claims.participant.read;
            },
            hasParticipantDeleteRights() {
                return this.$store.getters.claims.participant.delete;
            },
            hasParticipantWithPersonDeleteRights() {
                return this.$store.getters.claims.participantWithPerson.delete;
            },
            gridBtns() {
                let arr = [];

                arr.push({
                    name: "viewEvent",
                    text: "",
                    tooltip: this.$t('buttons.viewEvent.btnText'),
                    class: 'btn btn-primary',
                    icon: "fas fa-eye",
                    show: true,
                    clickHandler: this.eventDetailsBtnClick
                });

                if (this.hasParticipantEditRights) {
                    //arr.push({
                    //    name: "edit",
                    //    text: "",
                    //    tooltip: this.$t('buttons.edit.btnText'),
                    //    class: 'btn btn-primary',
                    //    icon: "fas fa-edit",
                    //    show: true,
                    //    clickHandler: this.editBtnClick
                    //});

                    arr.push({
                        name: "participantEditNew",
                        text: "",
                        tooltip: this.$t('buttons.edit.btnText'),
                        class: 'btn btn-primary',
                        icon: "fas fa-edit",
                        show: true,
                        clickHandler: this.participantEditNewBtnClick
                    });

                    arr.push({
                        name: "details",
                        text: "",
                        tooltip: this.$t('buttons.details.btnText'),
                        class: 'btn btn-info',
                        icon: "fas fa-eye",
                        show: true,
                        clickHandler: this.detailsBtnClick
                    });

                    arr.push({
                        name: "syncWithMoodle",
                        text: this.$t('buttons.syncWithMoodle.btnText'),
                        tooltip: this.$t('buttons.syncWithMoodle.btnText'),
                        class: 'btn btn-info',
                        icon: "fas fa-sync",
                        show: true,
                        clickHandler: this.syncWithMoodle
                    });
                }

                if (this.hasParticipantDeleteRights) {
                    if(this.allowParticipantsSoftDelete) {
                        arr.push({
                            name: "delete",
                            text: "",
                            tooltip: this.$t('buttons.delete.btnText'),
                            class: 'btn btn-danger',
                            icon: "fas fa-times",
                            show: true,
                            clickHandler: this.softDeleteBtnClick
                        });
                    }

                    arr.push({
                        name: "realDeleteParticipant",
                        text: "",
                        tooltip: this.$t('buttons.realDelete.btnText'),
                        class: 'btn btn-danger',
                        icon: "fas fa-times",
                        show: true,
                        clickHandler: this.realDeleteBtnClick
                    });
                }

                if (this.hasParticipantWithPersonDeleteRights) {
                    arr.push({
                        name: "deleteParticipantWithPerson",
                        text: "",
                        tooltip: this.$t('buttons.deleteWithPerson.btnText'),
                        class: 'btn btn-danger',
                        icon: "fas fa-times",
                        show: true,
                        clickHandler: this.deleteWithPersonBtnClick
                    });
                }

                if (this.hasPersonEditRights) {
                    arr.push({
                        name: "personEdit",
                        text: "",
                        tooltip: this.$t('buttons.personEdit.btnText'),
                        class: 'btn btn-primary',
                        icon: "fas fa-user-cog",
                        show: true,
                        clickHandler: this.personEditBtnClick
                    });
                    arr.push({
                        name: "personDetails",
                        text: "",
                        tooltip: this.$t('buttons.personDetails.btnText'),
                        class: 'btn btn-primary',
                        icon: "fas fa-info-circle",
                        show: true,
                        clickHandler: this.personDetailsBtnClick
                    });
                }

                return arr;
            }
        }
    }
</script>


<style>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: 'DejaVu Sans', 'Arial', sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit,
    .k-grid-details,
    .k-grid-delete,
    .k-grid-pdf,
    .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>
